import type { StatusBadgeVariant } from "../StatusBadge";

export const EVIDENCE_STATUSES = [
  "draft",
  "queued_for_analysis",
  "analyzing",
  "awaiting_review",
  "approved",
  "rejected_by_ai",
  "rejected_by_human",
  "failed",
] as const;

export type EvidenceStatus = (typeof EVIDENCE_STATUSES)[number];

const evidenceStatusLabels: Record<EvidenceStatus, string> = {
  draft: "Kladde",
  queued_for_analysis: "I kø til analyse",
  analyzing: "Analyseres",
  awaiting_review: "Afventer gennemgang",
  approved: "Godkendt",
  rejected_by_ai: "Afvist af AI",
  rejected_by_human: "Afvist",
  failed: "Fejlet",
};

const evidenceStatusVariants: Record<EvidenceStatus, StatusBadgeVariant> = {
  approved: "success",
  awaiting_review: "warning",
  queued_for_analysis: "warning",
  analyzing: "warning",
  rejected_by_ai: "danger",
  rejected_by_human: "danger",
  failed: "danger",
  draft: "secondary",
};

export const isEvidenceStatus = (status: string): status is EvidenceStatus =>
  (EVIDENCE_STATUSES as readonly string[]).includes(status);

export const formatEvidenceStatus = (status: string) =>
  isEvidenceStatus(status) ? evidenceStatusLabels[status] : status;

export const getEvidenceStatusVariant = (status: string): StatusBadgeVariant =>
  isEvidenceStatus(status) ? evidenceStatusVariants[status] : "muted";
